<template>
  <div class="venezuelan-government p-3">
    <h4>Venezuelan government entities found in FinCEN Files</h4>
    <p class="mb-0">Amounts related to transactions between 2009 - 2015 flagged as suspicious involving entities from Venezuela.</p>
    <stacked-bar-chart :data="data" x-axis-tick-format="$," label-above hide-legend :social-mode="socialMode" :fixed-height="height" />
    <p class="text-muted mt-2 small text-right">
      Source: FinCEN Files
    </p>
    <p class="mt-2 font-italic">This data is not representative of all SARs received by the U.S. Department of Treasury's Financial Crimes Enforcement Network.</p>
  </div>
</template>

<script>
import chart from '../mixins/chart'

export default {
  name: 'VenezuelanGovernment',
  mixins: [chart],
  data () {
    return {
      data: [
        { label: 'Ministry of Planning and Finance (Ministerio del Poder Popular de Planificacion y Finanzas)', value: 289331020 },
        { label: 'Veximca (Venezolana de Exportaciones e Importaciones, C.A.)', value: 230521271 },
        { label: 'PDVSA (ac pdvsa petroleo sa.)', value: 65340838 },
        { label: 'Corporation for Food Supply and Agricultural Services (Corporación de Abastecimiento y Servicios Agrícolas)', value: 18502763.18 }
      ]
    }
  }
}
</script>
